/**
 * KORAX Releasit Variant + Quantity Sync
 * v4 — 2026-09-18 — HOTFIX PARA PERDIDA DE VENTAS
 *
 * Sincroniza el widget de ofertas por cantidad KORAX con Releasit:
 *   - Variante (talla) del variant-picker de Horizon.
 *   - Cantidad del widget (que corresponde a un "offer" dentro de
 *     RSI_COD_FORM_QUANTIY_OFFERS de Releasit).
 *   - Selección de talla + color por unidad dentro del modal Releasit.
 *
 * Fix v4:
 *  - Fallback robusto a window.__KORAX_TIER_STATE cuando currentUnits está vacío
 *  - Retry escalonado (500/1200/2000/3000/4500 ms) en vez de un solo intento
 *  - Normalización con acentos/case en el matching (rosa palo == Palo Rosa)
 *  - Multi-dispatch (change + input + blur) para asegurar que Releasit reaccione
 *  - DEBUG activo para poder diagnosticar en vivo desde la consola
 */
(function () {
  'use strict';

  var DEBUG = true; // TEMPORAL: activar hasta confirmar que ventas fluyen
  var LOG_PREFIX = '[KORAX-SYNC]';
  function log() {
    if (!DEBUG) return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift(LOG_PREFIX);
    console.log.apply(console, args);
  }

  // ---------------------------------------------------------------
  // ESTADO INTERNO
  // ---------------------------------------------------------------
  var currentQty = 1;
  var currentOfferPos = null;
  var currentUnits = [];

  // ---------------------------------------------------------------
  // NORMALIZACIÓN (acentos + case + espacios)
  // ---------------------------------------------------------------
  function normalize(str) {
    if (str === null || str === undefined) return '';
    return String(str)
      .toLowerCase()
      .normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  // ---------------------------------------------------------------
  // FALLBACK: leer estado directo del widget si eventos fallaron
  // ---------------------------------------------------------------
  function readWidgetStateFallback() {
    var state = window.__KORAX_TIER_STATE;
    if (!state) return null;
    return {
      qty: state.currentQty,
      pos: state.currentPos,
      units: state.units || []
    };
  }

  function ensureFreshState() {
    // Si eventos no llegaron, leer directo del global
    if (!currentUnits || !currentUnits.length) {
      var s = readWidgetStateFallback();
      if (s && s.units && s.units.length) {
        currentUnits = s.units;
        if (s.qty) currentQty = s.qty;
        if (s.pos !== null && s.pos !== undefined) currentOfferPos = s.pos;
        log('State recovered from window.__KORAX_TIER_STATE', s);
      }
    }
  }

  // ---------------------------------------------------------------
  // VARIANT (TALLA)
  // ---------------------------------------------------------------
  function getSelectedVariantId() {
    var picker = document.querySelector('variant-picker input[type="radio"]:checked');
    if (picker && picker.dataset && picker.dataset.variantId) return picker.dataset.variantId;
    var select = document.querySelector('variant-picker select[name="id"], .product-form__input select[name="id"]');
    if (select && select.value) return select.value;
    var hidden = document.querySelector('input[name="id"]');
    if (hidden && hidden.value) return hidden.value;
    return null;
  }

  function updateReleasitVariant(variantId) {
    if (!variantId) return;
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', url.toString());
    } catch (e) { /* ignore */ }
    document.querySelectorAll('input[name="id"], input[name="variant_id"], input[name="variant-id"]').forEach(function (input) {
      if (input.value !== variantId) input.value = variantId;
    });
    document.querySelectorAll('[id*="releasit"], [class*="releasit"]').forEach(function (el) {
      el.setAttribute('data-variant-id', variantId);
      el.setAttribute('data-variant', variantId);
    });
    log('Variant synced:', variantId);
  }

  // ---------------------------------------------------------------
  // QUANTITY
  // ---------------------------------------------------------------
  function findQtyInput() {
    var selectors = [
      'quantity-selector input[name="quantity"]',
      'input[name="quantity"]',
      '.quantity__input',
      '[data-quantity-input]',
      'quantity-input input'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) return el;
    }
    return null;
  }

  function getCurrentQuantity() {
    var input = findQtyInput();
    if (input && input.value) {
      var n = parseInt(input.value, 10);
      if (!isNaN(n) && n > 0) return n;
    }
    return currentQty || 1;
  }

  function updateReleasitQuantity(qty) {
    if (!qty || qty < 1) qty = 1;
    currentQty = qty;
    var input = findQtyInput();
    if (input && parseInt(input.value, 10) !== qty) input.value = qty;
    document.querySelectorAll('[id*="releasit"], [class*="releasit"]').forEach(function (el) {
      el.setAttribute('data-quantity', qty);
      el.setAttribute('data-qty', qty);
    });
    document.querySelectorAll('input[name="quantity"], input[name="qty"]').forEach(function (i) {
      if (parseInt(i.value, 10) !== qty) i.value = qty;
    });
    log('Quantity synced:', qty);
  }

  // ---------------------------------------------------------------
  // FORZAR OFERTA EN EL MODAL RELEASIT
  // ---------------------------------------------------------------
  var forceObserver = null;
  var forceAttempts = 0;

  function findAndClickOfferByPos(pos) {
    var selector = '[data-offer-pos="' + pos + '"] ._rsi-quantity-offers-offer';
    var el = document.querySelector(selector);
    if (!el) return false;
    var container = el.closest('[data-offer-pos]');
    if (container && container.classList.contains('_rsi-quantity-offers-selected')) {
      return true;
    }
    el.click();
    log('Offer clicked at pos=' + pos);
    return true;
  }

  function forceReleasitOfferPos(pos) {
    if (pos === null || pos === undefined) return;
    if (pos === 0) return;
    if (findAndClickOfferByPos(pos)) return;

    if (forceObserver) forceObserver.disconnect();
    forceAttempts = 0;
    forceObserver = new MutationObserver(function () {
      forceAttempts++;
      if (findAndClickOfferByPos(pos)) {
        log('Offer clicked at pos=' + pos + ' after', forceAttempts, 'mutations');
        forceObserver.disconnect();
        forceObserver = null;
      } else if (forceAttempts > 150) {
        log('Giving up offer click after 150 mutations');
        forceObserver.disconnect();
        forceObserver = null;
      }
    });
    forceObserver.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () {
      if (forceObserver) { forceObserver.disconnect(); forceObserver = null; }
    }, 8000);
  }

  // ---------------------------------------------------------------
  // LISTENERS
  // ---------------------------------------------------------------
  function bindVariantPickerListener() {
    var picker = document.querySelector('variant-picker');
    if (picker) {
      picker.addEventListener('change', function () {
        setTimeout(function () {
          var vid = getSelectedVariantId();
          if (vid) updateReleasitVariant(vid);
        }, 30);
      });
    }
    document.querySelectorAll('input[name="id"]').forEach(function (i) {
      i.addEventListener('change', function () {
        if (i.value) updateReleasitVariant(i.value);
      });
    });
  }

  function bindQuantityWidgetListener() {
    document.addEventListener('korax:quantity-changed', function (e) {
      var qty = e && e.detail && e.detail.quantity;
      var pos = e && e.detail && e.detail.offerPos;
      var units = e && e.detail && e.detail.units;
      if (qty) updateReleasitQuantity(qty);
      if (pos !== null && pos !== undefined) currentOfferPos = pos;
      if (units && units.length) currentUnits = units;
      log('quantity-changed captured', { qty: qty, pos: pos, units: units });
    });
    document.addEventListener('korax:variants-changed', function (e) {
      var units = e && e.detail && e.detail.units;
      if (units && units.length) currentUnits = units;
      log('variants-changed captured', units);
    });
    var input = findQtyInput();
    if (input) {
      input.addEventListener('change', function () {
        var qty = parseInt(input.value, 10);
        if (!isNaN(qty)) updateReleasitQuantity(qty);
      });
    }
  }

  // ---------------------------------------------------------------
  // APLICAR SELECCIONES TALLA+COLOR EN MODAL RELEASIT
  // ---------------------------------------------------------------
  function applyReleasitVariantSelections(units) {
    if (!units || !units.length) return false;
    var selectedContainer = document.querySelector('._rsi-quantity-offers-offer-container._rsi-quantity-offers-selected');
    if (!selectedContainer) {
      log('applyReleasitVariantSelections: no selected container yet');
      return false;
    }

    var perUnitContainers = selectedContainer.querySelectorAll('._rsi-quantity-offers-variant-selector-multi-sel');
    var isMultiPattern = perUnitContainers.length > 0;
    if (!isMultiPattern) {
      perUnitContainers = selectedContainer.querySelectorAll('._rsi-quantity-offers-variant-selector');
    }
    if (!perUnitContainers.length) {
      log('applyReleasitVariantSelections: no per-unit containers yet');
      return false;
    }

    var applied = 0;
    perUnitContainers.forEach(function(unitContainer, unitIdx) {
      if (unitIdx >= units.length) return;
      var unit = units[unitIdx];
      var selects = unitContainer.querySelectorAll('select');
      selects.forEach(function(select, optIdx) {
        var targetVal = null;
        if (optIdx === 0) targetVal = unit.o1;
        else if (optIdx === 1) targetVal = unit.o2;
        else if (optIdx === 2) targetVal = unit.o3;
        if (!targetVal) return;

        var target = normalize(targetVal);
        var opts = Array.from(select.options);
        var matched = opts.find(function(o){
          return normalize(o.value) === target || normalize(o.text) === target;
        });

        if (matched && select.value !== matched.value) {
          select.value = matched.value;
          // Multi-dispatch para asegurar reactividad
          select.dispatchEvent(new Event('change', { bubbles: true }));
          select.dispatchEvent(new Event('input', { bubbles: true }));
          try {
            select.dispatchEvent(new Event('blur', { bubbles: true }));
          } catch(e){}
          applied++;
        } else if (!matched) {
          log('No match for target "' + targetVal + '" (unit ' + unitIdx + ', opt ' + optIdx + ')');
        }
      });
    });
    log('Applied to', applied, 'selects (multi=' + isMultiPattern + ', units=' + units.length + ')');
    return applied > 0;
  }

  // RETRY ESCALONADO — clave del fix v4
  function forceReleasitVariants(units) {
    if (!units || !units.length) {
      log('forceReleasitVariants: no units to apply');
      return;
    }

    // 5 intentos escalonados en distintos momentos
    var delays = [300, 800, 1500, 2500, 4000];
    delays.forEach(function(ms){
      setTimeout(function(){
        applyReleasitVariantSelections(units);
      }, ms);
    });

    // Además observer continuo por 6 segundos
    var attempts = 0;
    var obs = new MutationObserver(function() {
      attempts++;
      if (applyReleasitVariantSelections(units) || attempts > 200) {
        // NO desconectar — a veces Releasit re-renderiza y hay que re-aplicar
        if (attempts > 200) obs.disconnect();
      }
    });
    obs.observe(document.body, { childList: true, subtree: true });
    setTimeout(function(){ obs.disconnect(); }, 6000);
  }

  function bindReleasitClickInterceptor() {
    document.addEventListener('click', function (e) {
      if (!e.target) return;
      var isReleasitClick =
        e.target.closest('#rsi-button-hook') ||
        e.target.closest('[id*="releasit"]') ||
        e.target.closest('[class*="releasit"]') ||
        e.target.closest('[class*="_rsi-buy-now-button"]');
      if (!isReleasitClick) return;

      // CRITICAL: refrescar estado desde el widget global antes de aplicar
      ensureFreshState();

      var vid = getSelectedVariantId();
      var qty = getCurrentQuantity();
      if (vid) updateReleasitVariant(vid);
      if (qty) updateReleasitQuantity(qty);

      var targetPos = currentOfferPos;
      if (targetPos === null || targetPos === undefined) {
        var selectedTier = document.querySelector('.kv-widget [data-kv-tier].kv-tier--selected');
        if (selectedTier) {
          targetPos = parseInt(selectedTier.getAttribute('data-offer-pos') || '0', 10);
        }
      }
      if (targetPos !== null && targetPos > 0) {
        forceReleasitOfferPos(targetPos);
      }

      // Aplicar tallas+colores con retry escalonado
      if (currentUnits && currentUnits.length > 0) {
        forceReleasitVariants(currentUnits);
      } else {
        log('WARNING: no units to sync at click time. State:', {
          currentUnits: currentUnits,
          globalState: window.__KORAX_TIER_STATE
        });
      }

      log('Releasit click - variant:', vid, 'qty:', qty, 'pos:', targetPos, 'units:', currentUnits.length);
    }, true);
  }

  // ---------------------------------------------------------------
  // INIT
  // ---------------------------------------------------------------
  function init() {
    var initialVid = getSelectedVariantId();
    if (initialVid) updateReleasitVariant(initialVid);
    var initialQty = getCurrentQuantity();
    if (initialQty && initialQty > 1) updateReleasitQuantity(initialQty);
    bindVariantPickerListener();
    bindQuantityWidgetListener();
    bindReleasitClickInterceptor();

    // Poll suave por 3 segundos para captar la preselección del widget
    var pollCount = 0;
    var pollInterval = setInterval(function(){
      pollCount++;
      var s = readWidgetStateFallback();
      if (s && s.units && s.units.length) {
        if (!currentUnits.length) currentUnits = s.units;
        if (s.qty && currentQty === 1) currentQty = s.qty;
        if (s.pos !== null && currentOfferPos === null) currentOfferPos = s.pos;
        log('State polled from widget:', s);
        clearInterval(pollInterval);
      }
      if (pollCount > 30) clearInterval(pollInterval); // 3 seg
    }, 100);

    log('Init v4 complete');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
